<script setup lang="ts">
import { useOverlayStore } from "../store"
import { ref, watchEffect } from "vue"

const overlayStore = useOverlayStore()
const dialog = ref<HTMLDialogElement | null>(null)

watchEffect(() => {
    if (overlayStore.active) {
        dialog.value?.showModal()
    } else {
        dialog.value?.close()
    }
})
</script>

<template>
    <div
        class="overlay-container"
        role="dialog"
        aria-modal="true"
        aria-label="Overlay Dialog"
        :aria-hidden="!overlayStore.active"
    >
        <dialog
            v-if="overlayStore.active"
            ref="dialog"
            class="overlay-container align-content-md-center"
            @close.prevent
            @cancel.prevent
        >
            <!--
                Invisible focus target so showModal() does not focus the first link inside the overlay
                (Safari would scroll the dialog down to it). It must stay in the DOM on every breakpoint,
                so it is taken out of the flow instead of being hidden via display: none.
            -->
            <div class="focus-anchor" autofocus tabindex="-1"></div>
            <component :is="overlayStore.component" :props="overlayStore.props" />
        </dialog>
    </div>
</template>

<style scoped>
.focus-anchor {
    position: absolute;
    top: 0;
    left: 0;
    width: 0;
    height: 0;
    overflow: hidden;
    outline: none;
}

dialog {
    padding: 0;
    border: none;
    background: transparent;
    width: 100%;
    height: 100%;
}
</style>
